var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "check-outline.d51e8683.svg",
    width: 24,
    height: 24
});